import { render, staticRenderFns } from "./ImportAccessCodes.vue?vue&type=template&id=33a4b045&scoped=true&"
import script from "./ImportAccessCodes.vue?vue&type=script&lang=js&"
export * from "./ImportAccessCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a4b045",
  null
  
)

export default component.exports